<div class="smooth-scrolling without-sub-header">
    <!-- Contact detail start -->
    <section class="contact-detail p-80">
        <div class="mx-1485">
            <div class="row justify-content-center">
                <div class="col-lg-6">
                    <div class="main-title pt-lg-0 pt-0">
                        <h3 class="mt-lg-0 mt-md-0 mt-0">Contact Us</h3>
                        <span>We are delighted that you want to reach out and connect with us. We’re always
                            ready for a beauty-ful discussion.</span>
                        <span>
                            <ul class="text-section">
                                <li class="mb-3">Are you an old soul? Do you prefer writing letters? Here’s
                                    our mailing address for you. <br />ecommerce, 528-529-530 Florence Excellence, Besides Bright Day School, Vasna - Bhayli Main Rd, Vadodara-390015, Gujarat</li>
                                <li class="mb-3">Ohh, we see! Social Media enthusiast, is it? Not gonna lie,
                                    we are sailing in the same boat. Let’s follow, connect and be
                                    friends.<br />
                                    <div class="social me-3">
                                        <ul>
                                            <li>
                                                <a href="#" target="_blank">
                                                    <i class="fa-brands fa-linkedin-in"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href=" #" target="_blank">
                                                    <i class="fa-brands fa-instagram"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" target="_blank">
                                                    <i class="fa-brands fa-facebook-f"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" target="_blank">
                                                    <i class="fa-brands fa-youtube"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li class="mb-3">Do you find it the easiest to chat on WhatsApp? We’re there
                                    too, for you. Let’s chat.<br />
                                    <div class="social me-3">
                                        <ul>
                                            <li><a href="#" target="_blank"><i class="fa-brands fa-whatsapp"></i></a></li>
                                        </ul>
                                    </div>
                                </li>
                                <li class="mb-3">Are you in a hurry? Do you feel talking resolves
                                    everything? You can call us anytime from Monday to Friday, 10AM -
                                    7PM.<br />
                                    <div class="social me-3">
                                        <ul>
                                            <li><i class="fa-solid fa-phone me-2"></i><a href="#" target="_blank">00000 00000</a></li>
                                        </ul>
                                    </div>
                                </li>
                                <li>Want us to reach out to you with a solution or a beauty tip in exchange
                                    of a concern? Fill the form.</li>
                            </ul>
                        </span>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="contact-form">
                        <form [formGroup]="contactUsForm" (ngSubmit)="submitContactUsForm()">
                            <div class="mb-4">
                                <input type="text" placeholder="Name" id="name" formControlName="name">
                                <div *ngIf="contactUsf['name'].touched && contactUsf['name'].invalid"
                                    class="alert alert-danger alert-text">
                                    <div *ngIf="contactUsf['name'].errors && contactUsf['name'].errors['required']">
                                        Name is
                                        required.</div>
                                </div>
                            </div>
                            <div class="mb-4">
                                <input type="email" placeholder="Email" id="email" formControlName="email">
                                <div *ngIf="contactUsf['email'].touched && contactUsf['email'].invalid"
                                    class="alert alert-danger alert-text">
                                    <div *ngIf="contactUsf['email'].errors && contactUsf['email'].errors['required']">
                                        Email is
                                        required.</div>
                                    <div *ngIf="contactUsf['email'].hasError('pattern')">
                                        Email is invalid.
                                    </div>
                                </div>
                            </div>
                            <div class="mb-4">
                                <input placeholder="Phone" formControlName="subject" type="tel" maxlength="10"
                                    minlength="10">
                                <div *ngIf="contactUsf['subject'].touched && contactUsf['subject'].invalid"
                                    class="alert alert-danger alert-text">
                                    <div
                                        *ngIf="contactUsf['subject'].errors && contactUsf['subject'].errors['required']">
                                        Phone Number
                                        is
                                        required.</div>
                                    <div *ngIf="contactUsf['subject'].hasError('pattern')">
                                        Phone Number is invalid.
                                    </div>
                                </div>
                            </div>
                            <div class="mb-4">
                                <textarea placeholder="Message" rows="4" formControlName="message"></textarea>
                                <div *ngIf="contactUsf['message'].touched && contactUsf['message'].invalid"
                                    class="alert alert-danger alert-text">
                                    <div
                                        *ngIf="contactUsf['message'].errors && contactUsf['message'].errors['required']">
                                        Message is
                                        required.</div>
                                </div>
                            </div>
                            <button type="submit" [disabled]="contactUsForm.invalid" class="contact-button">Send</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Contact detail end -->
</div>
<!-- Footer START -->
<app-footer></app-footer>
<!-- Footer END -->